import { Card } from "@sportsmet/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { requireSignedIn } from "../auth/requireSignedIn";
import { DeleteAccountControl } from "../features/account/DeleteAccountControl";
import {
  DANGER_ZONE_LEAD,
  DANGER_ZONE_TITLE,
} from "../features/account/deleteAccountCopy";
import { HelpAndAboutCard } from "../features/account/HelpAndAboutCard";
import { PrivacyCard } from "../features/privacy/PrivacyCard";
import { SESSIONS_HEADING } from "../features/sessions/sessionsScreenLogic";
import { SIGN_IN_METHODS_HEADING } from "../features/signInMethods/signInMethodsScreenLogic";

const SettingsScreen = (): ReactNode => (
  <div className="flex flex-col gap-4">
    <h1 className="text-h1 text-ink">Settings</h1>
    <PrivacyCard />
    <Card title="Account">
      <div className="flex flex-col gap-3">
        <Link
          to="/settings/sign-in-methods"
          // min-h-touch-target is the 44px WCAG 2.2 floor (ISSUE-773): a bare
          // underlined text row measured 24px tall.
          className="flex min-h-touch-target items-center text-body text-primary underline underline-offset-4"
          data-testid="settings-sign-in-methods-link"
        >
          {SIGN_IN_METHODS_HEADING}
        </Link>
        <Link
          to="/settings/sessions"
          className="flex min-h-touch-target items-center text-body text-primary underline underline-offset-4"
        >
          {SESSIONS_HEADING}
        </Link>
        <Link
          to="/account/settings/notifications"
          className="flex min-h-touch-target items-center text-body text-primary underline underline-offset-4"
          data-testid="settings-notification-settings-link"
        >
          Notification settings
        </Link>
      </div>
    </Card>
    <HelpAndAboutCard />
    <Card title={DANGER_ZONE_TITLE}>
      <div className="flex flex-col gap-3">
        <p className="text-body text-ink-secondary">{DANGER_ZONE_LEAD}</p>
        <DeleteAccountControl />
      </div>
    </Card>
  </div>
);

export const Route = createFileRoute("/settings")({
  beforeLoad: requireSignedIn,
  component: SettingsScreen,
});
